import React from "react";
import {connect} from "react-redux";
import {setValues, setValues2, setValues3} from "../../Actions/AppActions";
import ModalInput from "./ModalComponents/ModalInput";

const ModalInputs = ({
                         forms,
                         setValues,
                         values,
                         innerSmallModal,
                         secondaryModal,
                         setValues2,
                         setValues3,
                     }) => {
    const handleChange = e => {
        if (secondaryModal.open) {
            setValues2({
                ...values,
                [e.target.name]: e.target.value,
            });
        }
        if (innerSmallModal) {
            setValues3({
                ...values,
                [e.target.name]: e.target.value,
            });
        } else {
            setValues({
                ...values,
                [e.target.name]: e.target.value,
            });
        }
    };
    return (
        <>
            {forms?.map(f => (
                <div className="grid_form" style={{gridTemplateColumns: f.grid}}>
                    {f.inputs.map(inp => (
                        <ModalInput
                            type={inp.type}
                            label={inp.label}
                            name={inp.name}
                            component={inp.component}
                            allDataType={inp.allData}
                            onChange={handleChange}
                            readOnly={inp.readOnly}
                            className={inp.className}
                            addBefore={inp.addBefore}
                            autoGetFocus={inp.autoGetFocus}
                            condition={inp.condition}
                            secondDate={inp.secondDate}
                            costumData={inp.costumData}
                            costumColumns={inp.costumColumns}
                        />
                    ))}
                </div>
            ))}
        </>
    );
};
const mapStateToProps = state => {
    return {
        values: state.app.innerSmallModal ? state.app.values3 :
            state.app.secondaryModal.open ? state.app.values2 : state.app.values,
        secondaryModal: state.app.secondaryModal,
        innerSmallModal: state.app.innerSmallModal,
    };
};
export default connect(mapStateToProps, {setValues, setValues2, setValues3})(ModalInputs);
